import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { FormAreaInput } from "../../wrappers/formArea";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { Button } from "ellow-web-ui-components-library";
import Styles from "./style.module.scss";
import StarRating from '../../compopnents/rating';
import { Error } from "@progress/kendo-react-labels";


export type CompanyForm = {
  overAllRating: any;
  communication: any;
  productivity: any;
  codeQuality: any;
  comment: any;
}

interface Props {
  clickHandler?: any;
  requestId?: any;
  requestDetails?: any;
  userLoginId?: any;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
const CompanyForm: React.FC<Props> = ({ clickHandler, requestId, requestDetails, userLoginId}) => {

  const validationSchema = Yup.object({})

  const formOptions = {
    resolver: yupResolver(validationSchema),
  }

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<CompanyForm>(formOptions)

  const { v4: uuidv4 } = require("uuid")

  const [error, setError] = useState<{overAllRating?: string, codeQuality?: string, productivity?: string,  communication?: string}>({overAllRating: '', codeQuality: '', productivity: '',  communication: ''})  
  const [disable, setDisable] = useState<boolean>()

  useEffect(() => {

    if(requestDetails.request_status === "Received"){
      setDisable(true)   
   } 

  },[requestDetails])
  
  const onSubmit = (data: any) => {

    let hasError: boolean = false
    if(!data.overAllRating){
      error.overAllRating = 'Field is required'
      hasError = true
    }
    if(!data.codeQuality){
      error.codeQuality = 'Field is required'
      hasError = true
    }
    if(!data.productivity){
      error.productivity = 'Field is required'
      hasError = true
    }
    if(!data.communication){
      error.communication = 'Field is required'
      hasError = true
    }
    if(!hasError){
      let values = {
        "action": "add",
        "section": "companyRatings",
        "loginId": requestDetails.candidate_id,
        "userLoginId": " ",
        "companyRatings": {
          "companyRatingId": uuidv4(),
          "companyId": uuidv4(),
          "ratingRequestId": requestDetails.assessment_request_id,
          "companyName": requestDetails.company_name,
          "designation": requestDetails.candidate_role,
          "overAllRating": data.overAllRating,
          "disabled": false,
          "startDate": requestDetails.contract_start_date,
          "endDate": requestDetails.contract_end_date,
          "comment": data.comment,
          "subRatings": {
            "productivity": data.productivity,
            "leadership": 0,
            "communication": data.communication,
            "codeQuality": data.codeQuality,
            "teamPlayer": 0,
          }
        }
      }    
      clickHandler(values)
    }else{    
      setError({...error})
    }
  }

  const changeOn = (e: any) => {
    setValue("comment",e.target.value) 
  }

  return (
    <form>
      <div className={Styles.ratingForm}>
      <div className={Styles.ratingHead}>
        Rate <span>"{requestDetails.candidate_name}"</span> as <span>"{requestDetails.candidate_role}"</span> at <span>"{requestDetails.company_name}"</span>
      </div>
      <div className={Styles.ratingWrapper}>
        <StarRating label={'Overall Ratings'} onChange={(e: any) => setValue('overAllRating', e.value)}/>
        <Error>{error?.overAllRating}</Error>
      </div>
      <div className={Styles.ratingStarWrapper}>
        <div className={Styles.skillsRatingBlock}>
          <label>Code quaility </label>
          <span><StarRating onChange={(e: any) => setValue('codeQuality', e.value)}/></span>
        </div>
        <Error>{error?.codeQuality}</Error>
        <div className={Styles.skillsRatingBlock}>
          <label>Productivity </label>
          <span><StarRating  onChange={(e: any) => setValue('productivity', e.value)}/></span>
        </div>
        <Error>{error?.productivity}</Error>
        <div className={Styles.skillsRatingBlock}>
          <label>Communication </label>
          <span><StarRating  onChange={(e: any) => setValue('communication', e.value)}/></span>
        </div>
        <Error>{error?.communication}</Error>
      </div>
      <div className="form-group">
        <FormAreaInput<CompanyForm>
          id="description"
          name="comment"
          placeholder="Comment about resource"
          register={register}
          onchange={(e: any) => changeOn(e)}
          errors={errors}>
        </FormAreaInput>
      </div>
      <div className={Styles.ratingAction}>
        <Button onClick={handleSubmit(onSubmit)} variant="primary" size="medium" disabled={disable}>
          Submit
        </Button>
      </div>
      </div>
    </form>
  )
}
export default CompanyForm
